import React from 'react'
import { useDrop } from 'react-dnd'
import { DRAGNDROP_TYPE } from '~/enums'
import { Context as DnDContext } from '../DnDContextProvider'
import { useLayerDropHandler } from './useLayerDropHandler'
import { useLayerCanDropItem } from './useLayerCanDropItem'

function useLayerDropTarget(ref, props) {
  const { layerId, layerIndex, scale } = props
  const handleDrop = useLayerDropHandler()
  const canDropItem = useLayerCanDropItem()
  const { setLayerHovered } = React.useContext(DnDContext)
  const acceptedTypes = [
    DRAGNDROP_TYPE.GROUP,
    DRAGNDROP_TYPE.LAYER_ASSET,
    DRAGNDROP_TYPE.MEDIA_ITEM,
    DRAGNDROP_TYPE.TEXT_ITEM,
    DRAGNDROP_TYPE.AUDIO_ITEM,
    DRAGNDROP_TYPE.IMAGE_ITEM,
    DRAGNDROP_TYPE.PREVIEW_MEDIA_ITEM,
  ]
  const [ collectedProps, drop ] = useDrop({
    accept: acceptedTypes,
    collect: monitor => ({
      isHovered: monitor.isOver(),
      item: monitor.getItem(),
    }),
    canDrop: item => canDropItem(item, acceptedTypes),
    drop: (item, monitor) => handleDrop(item, monitor, props),
  }, [ layerId, layerIndex, scale, canDropItem ])
  const { isHovered } = collectedProps

  React.useEffect(
    () => {
      setLayerHovered({ layerId, isHovered })
      return () => setLayerHovered({ layerId, isHovered: false })
    },
    [ setLayerHovered, layerId, isHovered ]
  )

  drop(ref)

  return collectedProps
}

export default useLayerDropTarget
